<template>
  <a-card :bordered="false">
    <a-form-model
      :model="form"
      :rules="rules"
      ref="ruleForm"
      :label-col="currentFormLayout.labelCol"
      :wrapper-col="currentFormLayout.wrapperCol"
    >
      <a-form-model-item label="AppID">
        <span>{{ form.id }}</span>
      </a-form-model-item>
      <a-form-model-item label="AppKey">
        <span class="resetWidth">{{ form.appKey }}</span>
        <a-button class="reset" @click="reset(1)">重置</a-button>
      </a-form-model-item>
      <a-form-model-item label="敏感信息解密">
        <span class="resetWidth">{{ form.sensitiveDecryption }}</span>
        <a-button class="reset" @click="reset(2)">重置</a-button>
      </a-form-model-item>
      <a-form-model-item label="是否应用昆仑ERP" prop="type">
        <a-radio-group v-model="form.type">
          <a-radio :value="0">否</a-radio>
          <a-radio :value="1">是</a-radio>
        </a-radio-group>
        <a-form-model-item
          v-if="form.type==1"
          style="display: inline-block;margin-bottom: 0"
          prop="erpDomain"
        >
          <a-input
            v-model="form.erpDomain"
            style="width: 392px;max-width: 500px;"
            @change="erpDomainOnChange"
            placeholder="支持https://及http://"></a-input>
        </a-form-model-item>
      </a-form-model-item>
      <a-form-model-item v-if="form.type==1" label="ERP管理员账号" prop="erpAdminLoginName">
        <a-input
          style="width: 500px"
          v-model="form.erpAdminLoginName"
          :maxLength="100"
          placeholder="请输入"
        ></a-input>
      </a-form-model-item>
      <a-form-model-item label="商品变动通知" prop="proChangeNotice">
        <a-input
          style="width: 500px"
          v-model="form.proChangeNotice"
          :maxLength="100"
          :disabled="form.type==1"
          placeholder="支持https://及http://"
        ></a-input>
      </a-form-model-item>
      <a-form-model-item label="订单变动通知" prop="orderChangeNotice">
        <a-input
          style="width: 500px"
          v-model="form.orderChangeNotice"
          :maxLength="100"
          :disabled="form.type==1"
          placeholder="支持https://及http://"
        ></a-input>
      </a-form-model-item>
      <a-form-model-item label="IP白名单" prop="ipWhitelist">
        <a-textarea
          :rows="10"
          style="width: 500px"
          placeholder="一行一个，最多10个"
          v-model="form.ipWhitelist"
        ></a-textarea>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
        <a-button type="primary" @click="onSave">保存</a-button>
        <a-button @click="backEvent" style="margin-left: 10px">返回</a-button>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
export default {
  name: 'ErpApiSetting',
  data() {
    return {
      currentFormLayout: {
        labelCol: {
          xxl: { span: 4 },
          xl: { span: 5 },
          lg: { span: 5 },
          sm: { span: 7 },
          md: { span: 10 },
          xs: { span: 12 }
        },
        wrapperCol: {
          xxl: { span: 20 }, //≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 19 }, //≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 17 }, //≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 17 }, //≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 14 }, //≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 12 } //xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        },
        offsetCol: {
          xxl: { offset: 4 },
          xl: { offset: 5 },
          lg: { offset: 5 },
          sm: { offset: 7 },
          md: { offset: 10 },
          xs: { offset: 12 }
        }
      },
      form: {
        proChangeNotice: '',
        orderChangeNotice: '',
        ipWhitelist: '',
        type: 0,
        erpDomain: '',
        erpAdminLoginName: ''
      },
      rules: {
        proChangeNotice: [
          { required: true, message: '请输入商品变动通知', trigger: 'blur' }
        ],
        orderChangeNotice: [
          { required: true, message: '请输入订单变动通知', trigger: 'blur' }
        ],
        ipWhitelist: [
          { required: true, message: '请输入白名单', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择是否应用昆仑ERP', trigger: ['blur', 'change'] }
        ],
        erpDomain: [
          { required: true, message: '请输入昆仑ERP地址', trigger: 'blur' },
          {
            pattern: /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/,
            message: '请输入正确的域名地址',
            trigger: 'blur'
          }
        ],
        erpAdminLoginName: [
          { required: true, message: '请输入ERP管理员账号', trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  /* watch: {
     'form.type': function(newVal, oldVal) {
       if (newVal !==1 && newVal !=='1') {
         this.form.erpDomain = ''//重置
       }
     }
   },*/

  created() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [{ name: 'ErpConnectList', title: '设置' }, {
      name: 'ErpApiSetting',
      title: 'API配置'
    }])
  },
  mounted() {
    this.getConfig()
  },
  methods: {
    erpDomainOnChange(val) {
      this.form.proChangeNotice = this.form.erpDomain + '/gateway/ota/api/product/touristLine/mfsync/directSyncTeamRouteNotice'
      this.form.orderChangeNotice = this.form.erpDomain + '/gateway/ota/api/order/touristLine/mfsync/directSyncTeamOrderNotify'
    },
    backEvent() {
      if (window.history.length <= 1) {
        this.$router.push({ path: '/' })
        return false
      } else {
        this.$router.go(-1)
      }
    },
    // 获取当前配置信息
    getConfig() {
      let params = {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      }
      this.getHttpServices()
        .getServerApiService()
        .post('directAssistant/search/getConfiguration', params)
        .then(res => {
          res.type = res.type ? res.type : 0
          this.form = res
          if (res.ipWhitelist != '' && res.ipWhitelist != null) {
            res.ipWhitelist = res.ipWhitelist.replace(',', '\n')
          }
        })
        .catch(reason => {
          console.error('getConfig', reason)
        })
    },
    /**
     * @param type  (integer, optional): 重置类型: 1AppKey 2敏感信息解密
     */
    reset(type) {
      let params = {
        id: this.form.id,
        type: type
      }
      this.getHttpServices()
        .getServerApiService()
        .post('directAssistant/operating/reset', params)
        .then(res => {
          if (type === 1) {
            this.form.appKey = res.appKey
          } else if (type === 2) {
            this.form.sensitiveDecryption = res.sensitiveDecryption
          }
        })
        .catch(reason => {
          this.$message.error('重置失败，请重试')
        })
    },
    onSave() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.requestSubmit()
        } else {
          return false
        }
      })
    },
    requestSubmit() {
      let reg = new RegExp('\n', 'g')
      let formParams = {
        ...this.form,
        ipWhitelist: this.form.ipWhitelist.split(reg).join(',')
      }
      this.getHttpServices()
        .getServerApiService()
        .post('directAssistant/operating/saveConfiguration', formParams)
        .then(res => {
          this.$message.success('保存成功')
          this.backEvent()
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }
}
</script>
<style scoped>
.resetWidth {
  display: inline-block;
  width: 200px;
}
</style>
